import React from 'react'
import PortfolioHome from './PortfolioHome'
import Breadcrumb from '../Breadcrumb/Breadcrumb'
import protofiloBanner from '../../asset/homefour/portfolio.webp';

const Portfolio = () => {
  return (
    <div>
        <Breadcrumb bannerImage={protofiloBanner} currentPage="Portfolio" />
        <PortfolioHome/>
    </div>
  )
}

export default Portfolio